import semver from 'semver';

import { WebViewBridge } from './WebViewBridge';

export interface SupportedFeaturesList {
  enableImageDownload: boolean;
  enableAttendanceDownload: boolean;
  enableDownloadUsingAnchor: boolean;
}

class SupportedFeaturesInApp implements SupportedFeaturesList {
  get enableImageDownload(): boolean {
    if (!WebViewBridge.isClasstingRNWebView()) {
      return true;
    }

    const appVersion = WebViewBridge.getClasstingRNAppVersion() as string;
    const targetVersion = '6.11.0';

    return semver.gte(appVersion, targetVersion);
  }
  get enableAttendanceDownload(): boolean {
    if (!WebViewBridge.isClasstingRNWebView()) {
      return true;
    }
    return false;
  }

  get enableDownloadUsingAnchor(): boolean {
    if (!WebViewBridge.isClasstingRNWebView()) {
      return true;
    }

    const appVersion = WebViewBridge.getClasstingRNAppVersion() as string;
    const targetVersion = '7.9.0';

    return semver.gte(appVersion, targetVersion);
  }
}

const supportedFeaturesInApp = new SupportedFeaturesInApp();

export default supportedFeaturesInApp;
